import { BasketOrder } from './basket-order.model';
import { LIST_ORDER_REFUND_ERROR, OrderRefundError } from './order-refund-error.model';
import { LIST_REFUNDED_STATUS, OrderRefundedStatus } from './basket-order-refunded-status.model';
import { BasketOrderRefunded } from './basket-order-refunded.model';

export class BasketOrderView extends BasketOrder {
  public fullname!: string;
  public refundable?: OrderRefundError;
  public refundedStatus?: OrderRefundedStatus;
  public basketOrdersRefunded: BasketOrderRefunded[] = [];
  public basketOrderOriginBillNumber?: string;

  constructor(data: any = {}) {
    super(data);
    this.fullname = data.fullname;
    this.refundable = data.refundable ? LIST_ORDER_REFUND_ERROR[data.refundable] : undefined;
    this.refundedStatus = data.refundedStatus ? LIST_REFUNDED_STATUS[data.refundedStatus] : undefined;
    this.basketOrdersRefunded = data.basketOrdersRefunded ? data.basketOrdersRefunded.map((v: any) => new BasketOrderRefunded(v)) : [];
    this.basketOrderOriginBillNumber = data.basketOrderOriginBillNumber;
  }
}
